// import React from 'react';
// import { Navigate } from 'react-router-dom';

// const PrivateRoute = ({ element: Component, ...rest }) => {

//     const isAuthenticated = localStorage.getItem("adminToken");

//     return isAuthenticated ? Component : <Navigate to="/admin/admin_login" replace />;
// };

// export default PrivateRoute;


import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ element }) => {
  const authToken = localStorage.getItem("authToken")?.trim(); 
  return authToken ? element : <Navigate to="/admin/admin_login" replace />;
};

export default PrivateRoute;
